var map = {
	"./ABB.png": 1145,
	"./BUSH.png": 9814,
	"./HDFC.png": 2479,
	"./HILTI.png": 1463,
	"./HUNGAMA.png": 7553,
	"./KENAMENTAL.png": 1902,
	"./LIVINGTREE.png": 2775,
	"./PEPSI.png": 9822,
	"./TATA.png": 7100,
	"./TOYOTA.png": 6253,
	"./TRANSGUARD.png": 7171
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1640;